
import { Component, Vue } from "vue-property-decorator";

@Component({
  filters: {
    formatProgress(value: number) {
      return value.toFixed(1) + "%";
    },
  },
})
export default class Info extends Vue {
  readonly targetQuantity = 4000;
  libraryQuantity = 0;
  donateQuantity = 0;
  donateProgress = 0;

  created() {
    this.getNum();
  }
  getNum() {
    this.ajax({
      method: "get",
      url: "/api/donate/num",
    }).then((res) => {
      const donateQuantity = res.data;
      this.donateQuantity = donateQuantity;

      const progress = (donateQuantity / this.targetQuantity) * 100;
      this.donateProgress = progress > 100 ? 100 : progress;

      this.libraryQuantity = Math.floor(donateQuantity / 3000);
    });
  }
}
